import { useNavigate } from "react-router-dom";
import useModule from "../../hooks/useModule";
import CustomTableLayout from "../../layouts/CustomTableLayout";

const fields = [
  "_RecordName",
  "Name",
  "PrimaryContactEmail",
  "Phone",
  "Status",
  "Created",
  "Tester",
];

const initialQuery = {
  Fields: fields,
  Filters: [],
  Pagination: {
    Count: 25,
    Page: 1,
  },
  OrderBy: {
    Field: "Created",
    Direction: "DESC",
  },
};

const mainLayout = {
  id: "1",
  Fields: fields,
  ModuleAPIName: "People",
  Type: "Table",
};
export default function TableUsersView({ urlStart }: { urlStart?: string }) {
  const navigate = useNavigate();
  urlStart = urlStart || "/supportal";

  const { module } = useModule("People");
  if (!module) return null;

  const recordNameField = "Name";
  const hiddenFields = ["Name"];

  return (
    <div className="px-3 pb-4">
      <CustomTableLayout
        title=""
        description=""
        module={module}
        emptyRecordName="Invited User - Pending"
        onOpenRecordName={(data: any) => {
          const record = data.record;
          navigate(`${urlStart}/${record._id}`);
        }}
        layout={mainLayout}
        initialQuery={initialQuery}
        hiddenFields={hiddenFields}
        recordNameField={recordNameField}
        stretch
        commentsWidget={false}
        providedCloudID={
          sessionStorage.getItem("LastVisitedTenant") || undefined
        }
        disableSave
      />
    </div>
  );
}
